import { render, staticRenderFns } from "./MarketRates.vue?vue&type=template&id=b36bcf66&scoped=true"
import script from "./MarketRates.vue?vue&type=script&lang=js"
export * from "./MarketRates.vue?vue&type=script&lang=js"
import style0 from "./MarketRates.vue?vue&type=style&index=0&id=b36bcf66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36bcf66",
  null
  
)

export default component.exports